import { Directive, ElementRef, inject, output } from '@angular/core';

/** Émet quand un clic a lieu en dehors de l'élément hôte — utilisé pour fermer les menus déroulants (`<details>`) au clic ailleurs sur la page. */
@Directive({
  selector: '[appClickOutside]',
  host: { '(document:click)': 'onDocumentClick($event)' },
})
export class ClickOutside {
  private readonly elementRef = inject(ElementRef<HTMLElement>);
  readonly appClickOutside = output<void>();

  onDocumentClick(event: MouseEvent): void {
    if (!this.elementRef.nativeElement.contains(event.target as Node)) {
      this.appClickOutside.emit();
    }
  }
}
